import React from 'react';
import PropTypes from 'prop-types';

const Input = (props) => {
    const {
        type = 'text',
        placeholder = '',
        onChange,
        className='w-full h-10 border p-2 text-sm',
        checked,
        name,
        value
    } = props;

    return (
        <input 
            className={className}
            type = {type} 
            placeholder={placeholder} 
            onChange={event => onChange(event)}
            checked = {checked}
            name={name}
            value={value}
        />
    )
}

Input.propTypes = {
    type: PropTypes.string,
    placeholder: PropTypes.string,
    onChange : PropTypes.func,
    className : PropTypes.string,
    checked : PropTypes.bool
};

export default Input;



